import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function FormLabel({ htmlFor, children, hidden }) {
    return (_jsx("label", { htmlFor: htmlFor, className: cn('text-body-sm text-neutral-fg font-medium text-nowrap', {
            'sr-only': hidden,
        }), children: children }));
}
